import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import router from './bootstrap/router';
import store from './bootstrap/store';
import './bootstrap/components';
import './bootstrap/global';
import './bootstrap/styles.css';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import './assets/sass/main.scss';

sync(store, router);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

store.commit('account/init');

if (!store.getters['account/isAuth'] && router.currentRoute.name !== 'login') {
  console.log('route', router.currentRoute);
  router.push({ name: 'login', params: { next: router.currentRoute.fullPath } });
}

router.beforeEach((to, from, next) => {
  if (!to.meta.noNeedAuth && !store.getters['account/isAuth']) {
    next({ name: 'login' });
  } else {
    next();
  }
});
